module.exports = __webpack_public_path__ + "img/afdekstrip_38mm.3db52c31.jpg";